// =============== USER ================= //
export const parseRawUser = (el) => ({
    activation_date: el.activation_date,
    bankAccountNumber: el.bank_account_number,
    bankAccountType: el.bank_account_type,
    bankCCI: el.bank_cci,
    bankBranch: el.bank_branch,
    bankCity: el.bank_city,
    bankCityId: el.bank_city_id,
    bankCountry: el.bank_country,
    bankCountryId: el.bank_country_id,
    bankName: el.bank_name,
    bankNameId: el.bank_name_id,
    birthDate: el.birth_date,
    firstLastName: el.first_last_name,
    firstName: el.first_name,
    gender: el.gender,
    idName: el.id_name,
    idNumber: el.id_number,
    idTypeId: el.id_type_id,
    maritalStatus: el.marital_status,
    mobileNumber: el.mobile_number ? `+${el.mobile_number}` : '',
    otherPhoneNumber: el.other_phone_number ? `+${el.other_phone_number}` : '',
    registerDate: el.register_date,
    residenceAddress: el.residence_address,
    role: el.role,
    secondFirstName: el.second_first_name,
    secondLastName: el.second_last_name,
    status: el.status,
    taxId: el.tax_id,
    userCityId: el.user_city_id,
    email: el.user_email,
    id: el.user_id,
    countryId: el.country_id,
    mustNotify: el.must_notify
});

// =============== PAYMENTS ================= //

export const parseRawPayment = (el) => ({
    adminId: el.admin_id,
    amountBeforeCommission: el.amount_before_commission,
    amountLocalCurrency: el.amount_local_currency,
    bankAccountId: el.bank_account_id,
    bankReference: el.bank_reference,
    currencyId: el.currency_id,
    dateCreated: el.date_created,
    description: el.description,
    extendedUserRelationId: el.extended_user_relation_id,
    id: el.id,
    infoChanged: el.info_changed,
    lastUpdated: el.last_updated,
    merchantId: el.merchant_id,
    mustNotify: el.must_notify,
    mustNotify_payee: el.must_notify_payee,
    notes: el.notes,
    payeeId: el.payee_id,
    processType: el.process_type,
    status: el.status,
    statusReason: el.status_reason,
    mustNotifyPayee: el.mustNotify_payee,
    currency: 'USD',
    localCurrency: el.code,
    fee: el.fee,
    paymentAmount: el.payment_amount,
    amountAfterCommission: el.amount_after_commission
});

export const parseRawPayments = (data) => data.map((el) => parseRawPayment(el));

// =============== NOTIFICATIONS ================= //

export const parseRawUserNotification = (el) => ({
    dateCreated: el.date_created,
    debugReason: el.debug_reason,
    description: el.description,
    emailSent: el.email_sent,
    emailTemplate: el.email_template,
    emailTitleKey: el.email_title_key,
    id: el.id,
    lastUpdated: el.last_updated,
    maxRetries: el.max_retries,
    mustSendEmail: el.must_send_email,
    notificationId: el.notification_id,
    reason: el.reason,
    receiverId: el.receiver_id,
    retries: el.retries,
    senderId: el.sender_id,
    status: el.status,
    subject: el.subject,
    userReceiverId: el.user_receiver_id
});

export const parseRawUserNotifications = (data) => data.map((el) => parseRawUserNotification(el));

// =============== STATISTICS ================= //

export const parseRawStats = (el) => ({
    completedPaymentCount: el.completed_payment_count,
    amountBeforeCommission: el.amount_before_commission,
    amountAfterCommission: el.amount_after_commission,
    userActivationStatus: el.user_activation_status
});
